import React from "react";
import SliderBox from "../components/landingpage/SliderBox";
import NavbarSkip from "../components/landingpage/NavbarSkip";

const LandingPage = () => {
 

  return (
    <div className="">
      <div className="lg:w-full  relative w-full   mx-auto ">
       

        <NavbarSkip />
        <div className="flex justify-center items-center w-full mt-10 ">
        <SliderBox  />
        </div>
        
      </div>
    </div>
  );
};

export default LandingPage;
